import api from '../services/axios.service';
import { constructQueryParams } from '../utils/utils';

export async function fetchTopics({ page_size, page_number, partial_name, entity_id, name }) {
    const queryParams = constructQueryParams({ page: page_number, page_size, partial_name, entity_id, name });

    return api.get(`/topics/details?${queryParams}`);
}

export async function fetchTopic(topic_id) {
    const queryParams = constructQueryParams({ topic_id });
    const response = await api.get(`/topics/details?${queryParams}`);

    return response?.result?.[0];
}

export async function fetchTopicConfigs() {
    return api.get(`/topics/configs`);
}

export async function fetchTopicStatistics() {
    return api.get('/topics/statistics');
}

export async function updateTopic(topic_id, data) {
    return api.put(`/topics/${topic_id}`, data);
}

export async function fetchTopicMessages(
    topic_id,
    {
        page_size,
        page,
        last_seen_offsets,
        first_seen_offsets,
        direction,
        sort = 'asc',
        seek_type = null,
        seek_value = null,
        regex = null,
        regex_search_fields = null
    } = {}
) {
    const queryParams = constructQueryParams({
        topic_id,
        page,
        last_seen_offsets,
        page_size,
        sort,
        direction,
        first_seen_offsets,
        seek_type,
        seek_value,
        regex,
        regex_search_fields
    });

    return api.get(`/topics/messages?${queryParams}`);
}

/**
 * Delete a topic by name.
 * @param {string} topicName - The name of the topic to delete.
 */
export async function deleteTopic(topicName) {
    return api.delete(`/topics/${encodeURIComponent(topicName)}`);
}
